class CC_Slider_Prd {
    constructor(slider, options = {}){
        this.options = Object.assign(
            {},
            {    
                class_child : ".media-full .media",
                class_parent_slider : ".media-full",
                class_medias_controller : ".content-medias-mob .medias",
                class_medias_controller_btn : ".content-medias-mob .media"
            }, 
            options
        );  
        this.slider = slider;
        this.medias = this.slider.querySelector(".medias");
        this.media =  this.medias.querySelectorAll(".media");
        this.mediaFull = this.slider.querySelectorAll(".content-media-full .media");
        this.currentSlide = 0; 
        this.saveTransition = this.slider.querySelector(this.options.class_parent_slider).style.transition;
        this.sliderLeft = this.slider.querySelector(".arrow.left");
        this.sliderRight = this.slider.querySelector(".arrow.right"); 

        window.addEventListener("resize", () => {
            this.reset();
        });

        this.media.forEach(m => {
            m.addEventListener("click", () => { 
                var index = parseInt(m.getAttribute("data-index"));
                if(index != this.currentSlide && this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"]`).classList.contains("video")){
                    this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"] video`).pause();
                };
                this.gotoStep(index);  
            });
        });  
 

        if(this.nbSlide > 1){ 
            this.sliderRight.addEventListener("click", () => { 
                if(this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"]`).classList.contains("video")){
                    this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"] video`).pause();
                };
                this.currentSlide += 1;
                this.gotoStep(this.currentSlide);
            });

            this.sliderLeft.addEventListener("click", () => {
                if(this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"]`).classList.contains("video")){
                    this.slider.querySelector(`.content-media-full .media[data-index="${this.currentSlide}"] video`).pause();
                };
                this.currentSlide -= 1;  
                this.gotoStep(this.currentSlide);
            });
        }
    }

    gotoStep(step){  
        let min = 0;
        let max = this.nbSlide - 1;    
        if(step <= 0){
            this.currentSlide = 0;
            if(this.sliderRight.classList.contains("off")){
                this.sliderRight.classList.remove("off");
            } 
            if(!this.sliderLeft.classList.contains("off")){
                this.sliderLeft.classList.add("off");
            } 
            if(this.slider.querySelector(".quote") != null && this.slider.querySelector(".quote").classList.contains("hide")){
                this.slider.querySelector(".quote").classList.remove("hide");
            }
        }
        if(step > 0){
            if(this.slider.querySelector(".quote") != null && !this.slider.querySelector(".quote").classList.contains("hide")){
                this.slider.querySelector(".quote").classList.add("hide");
            }
            if(step >= max){
                this.currentSlide = max;
                if(!this.sliderRight.classList.contains("off")){
                    this.sliderRight.classList.add("off");
                } 
                if(this.sliderLeft.classList.contains("off")){
                    this.sliderLeft.classList.remove("off");
                } 
            }else{
                this.currentSlide = step;
                if(this.sliderRight.classList.contains("off")){
                    this.sliderRight.classList.remove("off");
                }
                if(this.sliderLeft.classList.contains("off")){
                    this.sliderLeft.classList.remove("off")
                } 
            } 
        }    

        if(this.slider.querySelector(".content-media-full .media.active") != null){
            this.slider.querySelector(".content-media-full .media.active").classList.remove("active"); 
        }
        this.slider.querySelector(`.content-media-full .media[data-index="${step}"]`).classList.add("active"); 
       
        if( this.slider.querySelector(".medias .media.active") != null){
            this.slider.querySelectorAll(".medias .media.active").forEach(a => {a.classList.remove("active")});
        } 
        this.slider.querySelector(`.medias .media[data-index="${step}"]`).classList.add("active"); 

        
        let translateX = -(this.sizeSlide * this.currentSlide );  
        this.slider.querySelector(this.options.class_parent_slider).style.transition = this.saveTransition;
        this.slider.querySelector(this.options.class_parent_slider).style.transform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        this.slider.querySelector(this.options.class_parent_slider).style.WebkitTransform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        
 
        //video
        if(this.slider.querySelector(`.content-media-full .media[data-index="${step}"]`).classList.contains("video")){
            this.slider.querySelector(`.content-media-full .media[data-index="${step}"] video`).play();
        };

        //Efficacite ou Securite
        if(this.slider.querySelector(`.content-media-full .media[data-index="${step}"]`).classList.contains("no_label")){
            this.slider.querySelector(`.labels`).classList.add("hide");
        }else{
            if(this.slider.querySelector(`.labels`).classList.contains("hide")){
                this.slider.querySelector(`.labels`).classList.remove("hide");
            }
        }

    } 

    majMedias(id){ 
        let index = 0;
        document.querySelectorAll(".content-medias .content-media-full .media").forEach(media => { 
            if(media.getAttribute("data-vid") != null){
                if(media.getAttribute("data-vid") != id){
                    if(!media.classList.contains("hide")){
                        media.classList.add("hide");
                    }
                    media.setAttribute("data-index", ""); 
                }else{
                    if(media.classList.contains("hide")){
                        media.classList.remove("hide");
                    }
                    media.setAttribute("data-index", index);
                    index++;
                }
            }else{
                if(media.classList.contains("hide")){
                    media.classList.remove("hide");
                }
                media.setAttribute("data-index", index);
                index++;
            }
        });

        index = 0;
        document.querySelectorAll(".content-medias .content-medias-mob .media").forEach(media => { 
            if(media.getAttribute("data-vid") != null){
                if(media.getAttribute("data-vid") != id){
                    if(!media.classList.contains("hide")){
                        media.classList.add("hide");
                    }
                    media.setAttribute("data-index", ""); 
                }else{
                    if(media.classList.contains("hide")){
                        media.classList.remove("hide");
                    }
                    media.setAttribute("data-index", index);
                    index++;
                }
            }else{
                if(media.classList.contains("hide")){
                    media.classList.remove("hide");
                }
                media.setAttribute("data-index", index);
                index++;
            }
        });
    }

    reset(){
        this.currentSlide = 0;
        this.gotoStep(0);  
        let translateX = -(this.sizeSlide * this.currentSlide );  
        this.slider.querySelector(this.options.class_parent_slider).style.transition = "none";
        this.slider.querySelector(this.options.class_parent_slider).style.transform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        this.slider.querySelector(this.options.class_parent_slider).style.WebkitTransform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
    }

    get sizeSlide() {  
        return this.slider.querySelectorAll(this.options.class_child + ":not(.hide)")[0].offsetWidth;
    }

    get diffControllerMediaFull(){  
        let calDif = this.slider.querySelector(this.options.class_medias_controller).offsetWidth - this.slider.querySelectorAll(this.options.class_child)[0].offsetWidth;
        return calDif;
    }

    get sizeWindow() {
        return window.innerWidth;
    }

    get nbSlide() {
        return this.slider.querySelectorAll(this.options.class_child + ":not(.hide)").length;  
    }
 
}

var slider = new CC_Slider_Prd(document.querySelector(".content-medias"));